import { UIElements } from '@ansvar-sakerhet/ui';
import { styled } from 'styled-components';

const StatsInner = styled(UIElements.Flex)`
  width: 100%;
  background-color: white;
  padding: 20px;
  min-height: 700px;
  flex-direction: column;

  @media (min-width: 1350px) {
    width: calc(50% - 5px);
  }
`;

const Box = styled.div`
  width: 100%;
`;

const ColorBox = styled.div`
  width: 100px;
  height: 100px;
  background-color: white;
  border: 1.5px solid #d3d3d3;
  border-radius: 20%;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  display: flex;
  text-align: center;
  vertical-align: middle;
`;

const Warning = styled.p`
  padding: 8px 12px;
  border-left: 4px solid ${({ theme }) => theme.colors.warning};
  border-radius: 4px;
  background-color: #fff8d6;
  color: ${({ theme }) => theme.colors.black};
  font-size: 14px;
  line-height: 1.4;
`;

export const S = { ...UIElements, StatsInner, Box, ColorBox, Warning };
